module.exports = __webpack_public_path__ + "static/domain-whois_4-8c76e5056055ceee32d431cdb29e532f.jpg";